var map = {
	"./mobile/tdsScotland.png": "./src/components/tds/mobile/tdsScotland.png",
	"./tab/tdsScotland.png": "./src/components/tds/tab/tdsScotland.png",
	"./web/tdsScotland.png": "./src/components/tds/web/tdsScotland.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/tds sync recursive ^.*tdsScotland\\.png$";